export async function HttpNoData(url, method, jwt) {

    try {
        var response = await fetch(url, {
            method: method, // *GET, POST, PUT, DELETE, etc.
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + jwt
            }
        });

        if (response.ok) {

            try {
                var responsejson = await response.json();
                return { statusSuccessful: true, isDataEmpty: false, data: responsejson };
            } catch (error) {
                return { statusSuccessful: true, isDataEmpty: true, error: error };
            }
        }
        else return { statusSuccessful: false, error: response.status };

    } catch (error) {
        return { statusSuccessful: false, error: error };
    }
}

export async function HttpData(url, method, jwt, body) {
    try {
        console.log(url);
        var response = await fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + jwt
            },
            body: JSON.stringify(body),
        });

        if (response.ok) {
            try {
                var responsejson = await response.json();
                return { statusSuccessful: true, isDataEmpty: false, data: responsejson };
            } catch (error) {
                return { statusSuccessful: true, isDataEmpty: true, error: error };
            }
        }
        else {
            let errorBody;
            try {
                errorBody = await response.json();
            } catch {
                try {
                    errorBody = await response.text();
                } catch {
                    errorBody = null;
                }
            }

            return {
                statusSuccessful: false,
                error: response.status,
                errorData: errorBody
            };
        }

    } catch (error) {
        return { statusSuccessful: false, error: error };
    }
}

export async function DownloadFile(url, method, jwt, body, fileName) {

    try {
        var response = await fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + jwt
            },
            body: JSON.stringify(body),
        });

        if (!response.ok)
            return { statusSuccessful: false, error: response.status };

        try {

            const blob = await response.blob();
            const urlTemp = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = urlTemp;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return { statusSuccessful: true, isSave: true };
        } catch (error) {
            return { statusSuccessful: true, isSave: false };
        }
    } catch (error) {
        return { statusSuccessful: false, error: error };
    }
}

// date.toISOString() converts to UTC first, which shifts the calendar day
// backwards for positive UTC offsets (e.g. Moscow) whenever the local time
// is before offset:00 — use this instead to keep the day the user picked.
export function toLocalIsoDate(date) {
    const offsetMs = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offsetMs).toISOString().split('T')[0];
}

export function getRandomColor() {
    // Гарантируем, что цвет не слишком темный или светлый
    var getComponent = function () {
        var value = Math.floor(Math.random() * 256);
        return (value < 16 ? '0' : '') + value.toString(16);
    };

    var color = '#' + getComponent() + getComponent() + getComponent();
    return color;
}

export function getRandomInt(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
}

export function TimeOnlyParse(time) {

    var date = time.split(':');

    if (date.length == 3) {
        var hours = date[0];
        var minutes = date[1];
        var seconds = date[2];

        return hours + "ч. " + minutes + "мин. " + seconds + "сек.";
    }
    else if (date.length == 2) {
        var minutes = date[0];
        var seconds = date[1];

        return minutes + "мин. " + seconds + "сек.";
    }

    return '';
}

export function TimeSpanParse(value) {

    var points = value.split('.');

    if (points.length == 3)
        return points[0] + "д. " + TimeOnlyParse(points[1]);
    if (points.length == 2 || value.length >= 8)
        return TimeOnlyParse(points[0]);

    return '';
}

export function GetHoursOnTimeSpan(value) {
    var points = value.split('.');

    if (points.length == 3)
        return (+points[0] * 24) + +points[1].split(':')[0];
    if (points.length == 2 || value.length >= 8)
        return +points[0].split(':')[0];

    return '';
}

export function NormalStringTime(value) {

    return value.toLocaleString(undefined,
        {
            hour: 'numeric',
            minute: 'numeric'
        });
}

export function Exit() {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('user');
    window.location.href = '/';
}